export default "<div id=\"example\"></div>\r\n";